import { css } from '@/styled-system/css';

export const bannerBody = css({
  display: 'flex',
  flexDirection: { base: 'column', lg: 'row' },
  gap: 'default',
  justifyContent: 'space-between',
});

export const summary = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tightest',
});

export const actions = css({
  display: 'flex',
  flexDirection: { base: 'column', lg: 'row' },
  gap: 'tight',
});
